var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"data":_vm.missingCp303,"hoverable":true,"loading":_vm.loading},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('b-table-column',{attrs:{"label":"Produkt"}},[_vm._v(" "+_vm._s(props.row)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }